import { useState, useRef } from 'react';

import styles from './styles.module.scss';
import { EMOJIS } from 'constants/emoji';
import { useClickOutside } from 'hooks';

function EmojiSelect({ onClickEmoji }) {
  const [showBox, setShowBox] = useState(false);
  const emojiBoxRef = useRef(null);

  const handleClickOutsideEmojiBox = () => setShowBox(false);

  useClickOutside(emojiBoxRef, handleClickOutsideEmojiBox);

  const handleClickEmojiBtn = () => setShowBox(!showBox);

  const handleClickEmojiIcons = (emoji) => {
    onClickEmoji(emoji);
    if (window.innerWidth <= 425) {
      setShowBox(false);
    }
  };

  return (
    <div ref={emojiBoxRef}>
      <div
        className={`flex ${styles.emoji_btn}`}
        onClick={handleClickEmojiBtn}
      ></div>
      <div className={`${styles.emoji_box} ${showBox ? styles.show : ''}`}>
        {EMOJIS.map((emoji, index) => (
          <span
            key={index}
            onClick={() => handleClickEmojiIcons(emoji)}
            className={styles.emoji_item}
          >
            {emoji}
          </span>
        ))}
      </div>
    </div>
  );
}

export default EmojiSelect;
